import { differenceInYears } from 'date-fns'

// Возраст по дате рождения. bday — строка 'YYYY-MM-DD' или Date.
// null — дата не задана/невалидна.
export const getAge = (bday) => {
	if (!bday) return null

	const date = new Date(bday)
	if (Number.isNaN(date.getTime())) return null

	return differenceInYears(new Date(), date)
}

// Постановка «Родители и дети»: аккаунт для ребёнка младше 14 лет
// должен создать родитель (на сервере — 422).
export const isOlderThan = (bday, minAge = 14) => {
	const age = getAge(bday)
	return age !== null && age >= minAge
}
